import { render } from "./HeroEditor.vue?vue&type=template&id=4d5d5ab0&scoped=true"
import script from "./HeroEditor.vue?vue&type=script&lang=js"
export * from "./HeroEditor.vue?vue&type=script&lang=js"

import "./HeroEditor.vue?vue&type=style&index=0&id=4d5d5ab0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5d5ab0"]])

export default __exports__